var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getAppLoaded)?_c('div',{staticClass:"l-account container-fluid",style:(`background-image: url(${_vm.backgroundImage})`)},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"es-xs-12 es-lg-5 es-xl-4 u-padding-large-lg-up u-padding-xlarge-xl-up"},[_c('router-view')],1)])]):_c('div',[_vm._v("Loading")])])
}
var staticRenderFns = []

export { render, staticRenderFns }